// extracted by mini-css-extract-plugin
module.exports = {"madeWith":"_3r3w_m"};